import { render, staticRenderFns } from "./SigninCarousel.vue?vue&type=template&id=05736df4&"
import script from "./SigninCarousel.vue?vue&type=script&lang=js&"
export * from "./SigninCarousel.vue?vue&type=script&lang=js&"
import style0 from "./SigninCarousel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex})


/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05736df4')) {
      api.createRecord('05736df4', component.options)
    } else {
      api.reload('05736df4', component.options)
    }
    module.hot.accept("./SigninCarousel.vue?vue&type=template&id=05736df4&", function () {
      api.rerender('05736df4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/User/SigninCarousel.vue"
export default component.exports